/**
 * section-custom-packaging-finishes.js
 * – Chips clickeables sincronizados con el preview
 * – Flechas en el preview para navegar entre acabados
 * – Ambos controles están sincronizados entre sí
 * – Animación de entrada escalonada
 */

(function () {
  'use strict';

  var STAGGER_MS  = 110;
  var THRESHOLD   = 0.12;
  var ROOT_MARGIN = '0px 0px -48px 0px';

  /* ════════════════════════════════════════════
     ANIMACIONES DE ENTRADA
  ════════════════════════════════════════════ */
  function initAnimations(section) {
    var els = section.querySelectorAll('.pkg-fin__anim-el');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el    = entry.target;
        var delay = (parseInt(el.dataset.delay, 10) || 0) * STAGGER_MS;
        setTimeout(function () { el.classList.add('is-visible'); }, delay);
        observer.unobserve(el);
      });
    }, { threshold: THRESHOLD, rootMargin: ROOT_MARGIN });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ════════════════════════════════════════════
     LÓGICA DE UN BLOQUE (Peel o Metalizados)
  ════════════════════════════════════════════ */
  function initBlock(block) {
    var slides    = block.querySelectorAll('.pkg-fin__preview-slide');
    var chips     = block.querySelectorAll('.pkg-fin__chip');
    var labelEl   = block.querySelector('.pkg-fin__preview-label-text');
    var arrowPrev = block.querySelector('.pkg-fin__preview-arrow--prev');
    var arrowNext = block.querySelector('.pkg-fin__preview-arrow--next');

    if (!slides.length && !chips.length) return;

    var total   = Math.max(slides.length, chips.length);
    var current = 0;

    /* ── Activa un índice concreto ── */
    function goTo(index) {
      /* Clamp */
      index = Math.max(0, Math.min(index, total - 1));
      current = index;

      /* Slides */
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });

      /* Chips */
      chips.forEach(function (c, i) {
        var active = i === index;
        c.classList.toggle('pkg-fin__chip--active', active);
        c.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      /* Label */
      if (labelEl) {
        var activeChip = chips[index];
        var name = activeChip
          ? activeChip.querySelector('.pkg-fin__chip-name').textContent.trim()
          : '';
        labelEl.textContent = name;
      }

      /* Estado flechas */
      updateArrows();
    }

    /* ── Actualiza disabled de flechas ── */
    function updateArrows() {
      if (arrowPrev) arrowPrev.disabled = current === 0;
      if (arrowNext) arrowNext.disabled = current === total - 1;
    }

    /* ── Eventos chips ── */
    chips.forEach(function (chip, i) {
      chip.addEventListener('click', function () { goTo(i); });
    });

    /* ── Eventos flechas del preview ── */
    if (arrowPrev) {
      arrowPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(current - 1);
      });
    }

    if (arrowNext) {
      arrowNext.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(current + 1);
      });
    }

    /* ── Swipe en el preview (touch) ── */
    var preview   = block.querySelector('.pkg-fin__preview');
    var touchStartX = null;

    if (preview) {
      preview.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      preview.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 50) {
          goTo(current + (delta < 0 ? 1 : -1));
        }
        touchStartX = null;
      }, { passive: true });
    }

    /* ── Estado inicial ── */
    goTo(0);
  }

  /* ════════════════════════════════════════════
     INICIALIZACIÓN
  ════════════════════════════════════════════ */
  function initSection(section) {
    initAnimations(section);
    section.querySelectorAll('.pkg-fin__block').forEach(initBlock);
  }

  function init() {
    document
      .querySelectorAll('.section-custom-packaging-finishes')
      .forEach(initSection);
  }

  /* Soporte Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.section-custom-packaging-finishes');
    if (section) initSection(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
